import i18n from '@/i18n';

function isFrench(): boolean {
  const lang = i18n.language || 'en';
  return lang.split('-')[0] === 'fr';
}

/**
 * `url` must be one of the app's hardcoded apple.com/support.apple.com
 * literals, passed fresh on each call.
 */
export function getLocalizedAppleUrl(url: string): string {
  if (!isFrench()) return url;

  if (url.startsWith('https://business.apple.com')) {
    return url.replace(
      'https://business.apple.com',
      'https://business.apple.com/fr-ca/'
    );
  }

  return url.replace(
    /support\.apple\.com\/(en-us\/)?/,
    'support.apple.com/fr-ca/'
  );
}
